import type { IWidget } from "../widget-types/types";
import type { IDataFetcher, IDataFetcherFactory } from "./IDataFetcher";
import widgetResource from "app/common/resources/widgetResource";
import {
    fetchWithFullResponseConfig,
    fetchWithFullResponseInterceptorHandlers,
} from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

class MmxDashboardBarChartDataFetcherFactory<T> implements IDataFetcherFactory<T> {
    create(widget: IWidget<T>): IDataFetcher<T> {
        const params = { ...widget.apiParams };
        const componentId = params.webSource === devicesTypes.TOTAL ? "MarketingMixTotal" : "WebsiteOverviewDesktop";
        const resource = widgetResource.resourceByController(
            componentId,
            widget.apiParams.metric,
            fetchWithFullResponseConfig,
        ).PieChart;
        return {
            fetch: () =>
                resource(widget.apiParams)
                    .then(...fetchWithFullResponseInterceptorHandlers)
                    .then((response) => {
                        let result = response;
                        if (params.webSource === devicesTypes.TOTAL) {
                            result = { Data: { ...response?.Data?.Total } };
                        }
                        return result;
                    }),
            destroy: () => undefined,
        };
    }
}

export default new MmxDashboardBarChartDataFetcherFactory();
